<template>
  <v-container fluid>
    <v-row>
      <v-col class="text-h3 gray--text"> Conduta </v-col>
    </v-row>

    <MedicalRecordConductForm
      :attendance="attendance"
      :attendanceEsigned="attendanceEsigned"
    />

    <authorization permissionKey="attendance_glasses_prescription" can="read">
      <v-row>
        <v-col>
          <v-row dense>
            <v-col class="text-h5 gray--text"> Receitas de óculos </v-col>
          </v-row>

          <v-row dense>
            <v-col>
              <GlassPresciptionList
                :attendance="attendance"
                :allowEdit="false"
                :allowDelete="false"
              />
            </v-col>
          </v-row>
        </v-col>
      </v-row>
    </authorization>

    <authorization permissionKey="attendance_exam" can="read">
      <v-row>
        <v-col>
          <v-row dense>
            <v-col class="text-h5 gray--text"> Exames </v-col>
          </v-row>

          <v-row dense>
            <v-col>
              <ExamList
                :attendance="attendance"
                :attendanceEsigned="attendanceEsigned"
                :allowEdit="false"
                :allowDelete="false"
              />
            </v-col>
          </v-row>
        </v-col>
      </v-row>
    </authorization>

    <authorization permissionKey="attendance_prescription" can="read">
      <v-row>
        <v-col>
          <v-row dense>
            <v-col class="text-h5 gray--text"> Receituário </v-col>
          </v-row>

          <v-row dense>
            <v-col>
              <PrescriptionList
                :attendance="attendance"
                :allowEdit="false"
                :allowDelete="false"
              />
            </v-col>
          </v-row>
        </v-col>
      </v-row>
    </authorization>

    <authorization permissionKey="attendance_nursing" can="read">
      <v-row>
        <v-col>
          <v-row dense>
            <v-col class="text-h5 gray--text"> Terapêuticas </v-col>
          </v-row>

          <v-row dense>
            <v-col>
              <AttendanceTherapyList
                :attendance="attendance"
                :allowEdit="false"
                :allowDelete="false"
              />
            </v-col>
          </v-row>
        </v-col>
      </v-row>
    </authorization>

    <authorization permissionKey="attendance_medical_certificate" can="read">
      <v-row>
        <v-col>
          <v-row dense>
            <v-col class="text-h5 gray--text"> Atestados </v-col>
          </v-row>

          <v-row dense>
            <v-col>
              <MedicalCertificateList
                :attendance="attendance"
                :allowEdit="false"
                :allowDelete="false"
                :allowCreate="false"
              />
            </v-col>
          </v-row>
        </v-col>
      </v-row>
    </authorization>
  </v-container>
</template>

<script>
import MedicalRecordConductForm from "@/components/medical_record/conduct/form.vue";
import GlassPresciptionList from "@/components/glasses_prescription/list/index.vue";
import PrescriptionList from "@/components/prescription/list/index.vue";
import MedicalCertificateList from "@/components/medical_certificates/list/index.vue";
import AttendanceTherapyList from "@/components/attendance_therapy/list/index.vue";
import ExamList from "@/components/exam/list/index.vue";

export default {
  name: "Conduct",
  props: {
    attendance: Object,
    attendanceEsigned: Boolean,
  },
  components: {
    MedicalRecordConductForm,
    GlassPresciptionList,
    PrescriptionList,
    MedicalCertificateList,
    AttendanceTherapyList,
    ExamList,
  },
};
</script>

<style lang="scss" scoped></style>
